import service from '@/utils/https';
import type { AxiosResponse } from 'axios';
import type { ApiResponse } from '@/types';
import type { CoverLetterAnalysisRequest, CoverLetterAnalysisResponse, CoverLetterAnalysisDetailResponse, CoverLetterAnalysisPrefillResponse } from '@/types/coverLetterAnalysis';

/**
 * 分析 Cover Letter
 * API: POST /v1/analysis/cl/analyze
 */
export function analyzeCoverLetter(data: CoverLetterAnalysisRequest): Promise<AxiosResponse<ApiResponse<CoverLetterAnalysisResponse>>> {
  return service({
    url: '/v1/analysis/cl/analyze',
    method: 'post',
    data,
    timeout: 180 * 1000, // 3分钟，与页面超时保持一致
  });
}

/**
 * 获取 Cover Letter 分析详情
 * API: GET /v1/analysis/cl/:record_id
 */
export function getCoverLetterAnalysisDetail(recordId: string | number): Promise<AxiosResponse<ApiResponse<CoverLetterAnalysisDetailResponse>>> {
  return service({
    url: `/v1/analysis/cl/${recordId}`,
    method: 'get',
  });
}

/**
 * 获取 Cover Letter 分析预填写数据
 * API: GET /v1/prefill/cl-analysis
 */
export function getCoverLetterAnalysisPrefill(): Promise<AxiosResponse<ApiResponse<CoverLetterAnalysisPrefillResponse>>> {
  return service({
    url: '/v1/prefill/cl-analysis',
    method: 'get',
  });
}
